import { drybulkCargoOperationsService } from "@services/drybulkCargoOperationsApi";
import { useQuery } from "@tanstack/react-query";
import { DRYBULK_CARGO_OPS_QUERY_KEYS } from "../constants";

export const useOperationNominations = (operationId: string | undefined, enabled: boolean) =>
  useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.operationNominations(operationId ?? ""),
    queryFn: () => drybulkCargoOperationsService.getOperationNominations(operationId!),
    enabled: enabled && Boolean(operationId),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
    retry: false,
  });
